<form [formGroup]="form" (ngSubmit)="model ? update() : create()" appPermissionControl="P252F0001">
  <div class="form-row mt-3">
    <div class="form-field">
      <input pInputText type="text" formControlName="numero_Proceso" class="form-control"
        [placeholder]="'Ingrese N° Ruta'" [disabled]="model" appPermissionControl="P252K0001">
      <label>N° Ruta</label>
    </div>
  </div>
  <div class="form-row">
    <div class="form-field">
      <input pInputText type="text" formControlName="descriptivo" class="form-control"
        [placeholder]="'Ingrese descripción'" appPermissionControl="P252K0002">
      <label>Descripción</label>
    </div>
  </div>
  <div class="form-row">
    <div class="form-field">
      <input pInputText type="number" formControlName="costo" class="form-control" [placeholder]="'Ingrese costo'"
        min="0" appPermissionControl="P252K0003">
      <label>Costo</label>
    </div>
  </div>
  <div class="form-row">
    <div class="form-field">
      <input pInputText type="number" formControlName="duracion" class="form-control" [placeholder]="'Ingrese duración'"
        min="0" appPermissionControl="P252K0004">
      <label>Duración</label>
    </div>
  </div>
  <div class="button-section">
    <button mat-flat-button class="btn-success btn-menu" type="submit" [disabled]="!form.valid || loading" appPermissionControl="P252B0001">
      <mat-icon>save</mat-icon>
      {{ model ? 'Actualizar' : 'Guardar' }}
    </button>
    <button *ngIf="model" mat-flat-button class="btn-search btn-menu" type="button" (click)="openCustomizables()" appPermissionControl="P252B0002">
      <mat-icon>tune</mat-icon>
      Customizables
    </button>
  </div>
  <div class="button-section">
    <button *ngIf="model" mat-flat-button class="btn-new btn-menu" type="button" (click)="openActividadesDialog()" appPermissionControl="P252B0003">
      <mat-icon>list</mat-icon>
      Actividades
    </button>
    <button *ngIf="model" mat-flat-button class="btn-menu btn-back" type="button" (click)="openRutasDialog()" appPermissionControl="P252B0004">
      <mat-icon>alt_route</mat-icon>
      Rutas
    </button>
  </div>
</form>

<style>
  :host ::ng-deep .form-row {
    display: flex;
    flex-direction: row;
    margin-bottom: 1rem;
  }

  :host ::ng-deep .form-field {
    flex: 1;
    display: flex;
    flex-direction: column-reverse;
    position: relative;
  }

  :host ::ng-deep .form-control {
    width: 100%;
    padding: 0.5rem;
    font-size: 1rem;
    border: 1px solid #ced4da;
    border-radius: 4px;
    background: #fff;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  }

  :host ::ng-deep .form-control:disabled {
    background: #e0e0e0 !important;
    color: #555 !important;
    opacity: 1 !important;
  }

  :host ::ng-deep .form-field label {
    font-size: 0.85rem;
    color: #6c757d;
    margin-bottom: 0.25rem;
  }

  :host ::ng-deep .button-section {
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
    margin-top: 1.5rem;
  }
</style>